import { Injectable } from '@angular/core';
import { CanActivate, Router, RouterStateSnapshot } from '@angular/router';
import { LocalStorage } from '../_api/localstorage';
import { SharedHttpService } from './../services/shared-http.service';

@Injectable({
  providedIn: 'root'
})
export class LookupService {
    lookupData:any;

    constructor(public sharedService : SharedHttpService) { 
    }

    setLockup(data){
        this.lookupData = data;
    }

    getLockup(key){
        let data;
        if(this.lookupData){
            this.lookupData.map(el=>{
                if(el['key'] === key){
                    data = el['data'];
                }
            })
        }else if(JSON.parse(localStorage.getItem('lookup'))){
            let localStorageLookup : [] = JSON.parse(localStorage.getItem('lookup'));
            localStorageLookup.map(el=>{
                if(el['key'] === key){
                    data = el['data'];
                }
            })
        }else{
            this.sharedService.get('api/Lookup/GetAllLookups').subscribe(res=>{
                localStorage.setItem('lookup',JSON.stringify(res));
                this.lookupData = res;
            })
        }
        return data ;
    }

}
